import React from 'react';
import {
  Icon,
  LoadingCircleAccentedIcon,
  RadioCheckMarkCheckedIcon,
} from '@taopix/taopix-design-system';
import {ProgressState} from './WaitingDialog';
import classNames from 'classnames';

export interface WaitingDialogItemProps {
  label: string;
  state: ProgressState;
}

const WaitingDialogItem = ({label, state}: WaitingDialogItemProps) => {
  const listItemClasses = classNames('flex', 'relative', 'items-center', 'pl-xl', 'mb-sm');
  const labelClasses = classNames(
    (state === ProgressState.COMPLETE || state === ProgressState.FORCECOMPLETE) && 'opacity-50'
  );

  return (
    <li className={listItemClasses}>
      {state === ProgressState.PROCESSING && (
        <Icon icon={<LoadingCircleAccentedIcon />} className={'absolute left-0'} />
      )}
      {(state === ProgressState.COMPLETE || state === ProgressState.FORCECOMPLETE) && (
        <Icon
          icon={<RadioCheckMarkCheckedIcon />}
          className={'absolute left-0'}
          colour={'themeAccentColour'}
        />
      )}
      <span className={labelClasses}>{label}</span>
    </li>
  );
};

export default WaitingDialogItem;
